export default __webpack_public_path__ + "static/media/galaxy.4d061f95.png";